<pbc-filter [config]="ZeitenFilterConfig" [filter]="zeiten.filter$ | async" (filterChange)="zeiten.filter$.next($event)"></pbc-filter>
